"use client";
import React, { useCallback, useState } from "react";
import { TurnrCard } from "~/components/card/TurnrCard.jsx";
import { TurnrTableBody, TurnrTableCell, TurnrTableRow, TurnrTableSimple } from "~/components/table/TurnrTableSmart.jsx";
import { TurnrButton } from "~/components/buttons/TurnrButton";
import TurnrModal, { TurnrModalContent, TurnrModalDescription, TurnrModalFooter, TurnrModalTitle } from "~/components/modals/TurnrModal.jsx";
import EntityActionFormModal from "~/components/entityAction/modals/EntityActionFormModal.jsx";
import { formParameterToEntityAction } from "~/components/entityAction/utils/entityActionsCore.js";
import AddItemRow from "./AddItemRow";
import { ItemRowTitle, ItemRowTitleOrder } from "../ReportItemRow";

export default function AddItemModal({ appProps, open, onClose, onAddItem, onAddCustomItem, addedCustomItems, onRemoveItem, onRemoveCustomItem, qualityCheckOrderFullServiceData, allSelectedItems }) {
    const itemsWithoutReturns = qualityCheckOrderFullServiceData?.data?.itemsWithoutReturn;

    const [addCustomItemOpen, setAddCustomItemOpen] = useState(false);

    const customItemForm = qualityCheckOrderFullServiceData?.data?.addCustomItemForm;

    const onAddCustomItemSubmit = useCallback(
        (data, e) => {
            e?.preventDefault();
            e?.stopPropagation();
            setAddCustomItemOpen(false);
            onAddCustomItem(data);
        },
        [onAddCustomItem, setAddCustomItemOpen],
    );

    return (
        <TurnrModal open={open} onClose={onClose}>
            <TurnrModalTitle>Add items</TurnrModalTitle>
            <TurnrModalDescription>
                <div>
                    You can find all items connected to the order here and find the one best matching the item you found in the package. If you can't find the item you can also manually describe what
                    item you have found in the package
                </div>
            </TurnrModalDescription>
            <TurnrModalContent>
                <EntityActionFormModal
                    appProps={appProps}
                    onSubmit={onAddCustomItemSubmit}
                    entityAction={formParameterToEntityAction(customItemForm, { label: "Add custom item" })}
                    open={addCustomItemOpen}
                    onClose={setAddCustomItemOpen}
                />
                {/*<EntityActionForm formValues={{}} formParameters={customItemForm?.formParameters} appProps={appProps} />*/}
                {/*<HandleEntityActionForm appProps={appProps} entityAction={customItemForm} />*/}
                <TurnrCard>
                    <TurnrTableSimple>
                        <TurnrTableBody>
                            {itemsWithoutReturns?.length > 0 && <ItemRowTitleOrder />}
                            {itemsWithoutReturns?.map((orderItem) => {
                                const isAlreadyAdded = !!allSelectedItems?.find((item) => item?.qualityCheckItemId === orderItem?.qualityCheckItemId);
                                return (
                                    <AddItemRow
                                        key={orderItem?.qualityCheckItemId}
                                        appProps={appProps}
                                        orderItem={orderItem}
                                        isAlreadyAdded={isAlreadyAdded}
                                        onAddItem={onAddItem}
                                        onRemoveItem={isAlreadyAdded && (() => onRemoveItem(orderItem))}
                                    />
                                );
                            })}

                            {addedCustomItems?.length > 0 && <ItemRowTitle title={"Custom items"} />}
                            {addedCustomItems?.map((customItem) => {
                                return (
                                    <AddItemRow
                                        key={customItem?.qualityCheckItemId}
                                        appProps={appProps}
                                        customItem={customItem}
                                        isAlreadyAdded={true}
                                        onRemoveItem={() => onRemoveCustomItem(customItem)}
                                    />
                                );
                            })}
                            <TurnrTableRow>
                                <TurnrTableCell colSpan={4} fullWidth={true}>
                                    <TurnrButton
                                        fullWidth={true}
                                        tooltipContent={
                                            "Only add custom items if none of the listed items apply. Custom items are used solely to ensure reporting accuracy and will not trigger any automated actions."
                                        }
                                        variant={"text"}
                                        style={{ height: "50px" }}
                                        onClick={() => setAddCustomItemOpen(true)}
                                    >
                                        Add custom item
                                    </TurnrButton>
                                </TurnrTableCell>
                            </TurnrTableRow>
                        </TurnrTableBody>
                    </TurnrTableSimple>
                </TurnrCard>
            </TurnrModalContent>
            <TurnrModalFooter showSubmitButton={false} cancelText={"Close"} onCancel={onClose} />
        </TurnrModal>
    );
}
